import { NgModule } from '@angular/core';
import { BrowserModule, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { ColorPickerModule } from 'ngx-color-picker';
import { IonicModule } from '@ionic/angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { Globalization } from '@ionic-native/globalization/ngx';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateConfigService } from './services/language/languages.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularFireModule } from '@angular/fire/compat';
import { firebaseConfig } from './../environments/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthService } from './services/auth/auth.service';
import { BarcodeScanner } from '@ionic-native/barcode-scanner/ngx';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { BLE } from '@awesome-cordova-plugins/ble/ngx';
import { BluetoothSerial } from '@ionic-native/bluetooth-serial/ngx';
import { IonicGestureConfig } from '../app/utils/ionic-gesture-config.service';
import { UpdateAppComponent } from './components/shared/update-app/update-app.component';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

var config = {
    statusbarPadding: true
}

@NgModule({
    declarations: [
        AppComponent,
        UpdateAppComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        AngularFireModule.initializeApp(firebaseConfig),
        ColorPickerModule,
        IonicModule.forRoot({
            backButtonText: '',
            mode: 'ios',
            backButtonIcon: 'arrow-back-outline'
        }),
        TranslateModule.forRoot({
            defaultLanguage: 'es',
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    providers: [
        {
            provide: LocationStrategy,
            useClass: PathLocationStrategy
            // provide: RouteReuseStrategy,
            // useClass: IonicRouteStrategy,
        },
        TranslateConfigService,
        Globalization,
        AuthService,
        BarcodeScanner,
        {
            provide: HAMMER_GESTURE_CONFIG,
            useClass: IonicGestureConfig
        },
        BluetoothSerial,
        BLE,
    ],
    bootstrap: [
        AppComponent
    ]
})
export class AppModule { }
